var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHackerrank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 640 l0 -640 640 0 640 0 0 640 0 640 -640 0 -640 0 0 -640z m400 160 l0 -80 40 0 40 0 0 80 0 80 80 0 80 0 0 -240 0 -240 -80 0 -80 0 0 80 0 80 -40 0 -40 0 0 -80 0 -80 -80 0 -80 0 0 240 0 240 80 0 80 0 0 -80z m640 -160 l0 -240 -160 0 -160 0 0 240 0 240 160 0 160 0 0 -240z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackerrank);
export default __webpack_public_path__ + "static/media/hackerrank.c0fd1e767ae1c659c744d4f022341293.svg";
export { ForwardRef as ReactComponent };